import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import {useEvent} from 'Event/EventProvider'
import {useObieAttendeeLinks} from 'lib/event-api/integrations/obie/attendee-links/list'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import Button from 'lib/ui/Button'
import AddAttendeeLinkDialog from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks/AddAttendeeLinkDialog'
import AttendeeLinkRow from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks/AttendeeLinkRow'
import EditAttendeeLinkDialog from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks/EditAttendeeLinkDialog'
import {useOrganization} from 'organization/OrganizationProvider'
import React, {useState} from 'react'
import styled from 'styled-components'

export interface AttendeeLinksProps {
  obieHubId: string
}

export default function AttendeeLinks(props: AttendeeLinksProps) {
  const {obieHubId} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const {data: links = [], error} = useObieAttendeeLinks({client, event})
  const [showingAddDialog, setShowingAddDialog] = useState(false)
  const [editingLinkId, setEditingLinkId] = useState<number | null>(null)

  const editingLink = links.find((link) => link.id === editingLinkId)

  return (
    <Section>
      <Typography variant="h6">More attendee links</Typography>
      <Description variant="body2" color="textSecondary">
        Each link opens one journey, milestone or step after the attendee logs
        in.
      </Description>

      <ErrorAlert>{error?.message ?? null}</ErrorAlert>

      {links.length > 0 && (
        <LinksTable>
          <Table aria-label="attendee links">
            <TableHead>
              <TableRow>
                <TableCell>Label</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Destination</TableCell>
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {links.map((link) => (
                <AttendeeLinkRow
                  key={link.id}
                  link={link}
                  obieHubId={obieHubId}
                  onEdit={() => setEditingLinkId(link.id)}
                />
              ))}
            </TableBody>
          </Table>
        </LinksTable>
      )}

      <Button
        variant="outlined"
        color="primary"
        aria-label="add attendee link"
        onClick={() => setShowingAddDialog(true)}
      >
        Add attendee link
      </Button>

      <AddAttendeeLinkDialog
        showing={showingAddDialog}
        obieHubId={obieHubId}
        onClose={() => setShowingAddDialog(false)}
      />

      {editingLink && (
        <EditAttendeeLinkDialog
          key={editingLink.id}
          link={editingLink}
          obieHubId={obieHubId}
          onClose={() => setEditingLinkId(null)}
        />
      )}
    </Section>
  )
}

const Section = styled.div`
  margin: ${(props) => props.theme.spacing[6]} 0;
`

const LinksTable = styled(TableContainer)`
  margin-bottom: ${(props) => props.theme.spacing[3]};
`

const Description = styled(Typography)`
  margin-bottom: ${(props) => props.theme.spacing[3]};
`
